/**
 *  Enum for easy code-access to the key-values in the app's config JSON. If a property is renamed in the JSON, we have
 *  an easy place to replace all code references.
 */
export enum CONFIG_KEY {
  DTW_CATEGORY_ID              = 'dtwCategoryId',
  FNF_CATEGORY_ID              = 'fnfCategoryId',

  IS_UAT                       = 'isUat',
  USER_ROLES                   = 'userRoles',

  ENABLE_ADD_TO_HOTLIST        = 'enableAddToHotlist',
  ENABLE_REMOVE_FROM_HOTLIST   = 'enableRemoveFromHotlist',
  ENABLE_DTW                   = 'enableDtw',
  ENABLE_CORRECTIVE_REDEMPTION = 'enableCorrectiveRedemption',
  MANAGE_DAYS                  = 'manageDays',
  MANAGE_USERS                 = 'manageUsers',
  MANAGE_RESORT_ADMIN          = 'manageResortAdmin',
  MANAGE_SYSTEM_ADMIN          = 'manageSystemAdmin',
  ENABLE_CUSTOMER_IMPORT       = 'enableCustomerImport',

  ENABLE_FRIENDS_AND_FAMILY    = 'enableFriendsAndFamily',
};
